import { FC, useEffect, useState } from 'react';
import './SubsectionView.scss';
import MainNavbar from '../../../components/MainNavbar/MainNavbar';
import HeaderPage from '../../../components/HeaderPage/HeaderPage';
import { Col, Container, Row } from 'react-bootstrap';
import BreadcrumbPage from '../../../components/BreadcrumbPage/BreadcrumbPage';
import { useArticles } from '../../../providers/Articles/ArticlesProvider';
import { useSubsections } from '../../../providers/Articles/Subsections/SubsectionsProvider';
import { useParams } from 'react-router-dom';
import ListArticlesView from '../../../components/Articles/ListArticlesView/ListArticlesView';
import ScrollTopButton from '../../../components/ScrollTopButton/ScrollTopButton';

interface SubsectionViewProps { }

const SubsectionView: FC<SubsectionViewProps> = () => {
  const [category, setCategory] = useState<any>(null);
  const [section, setSection] = useState<any>(null);

  const { articlesStructure, handleListByStructure } = useArticles();
  const { subsections, setParams } = useSubsections();

  const { id } = useParams<{ id: string }>();

  const currentSubsection = subsections[0];

  useEffect(() => {
    if (id) {
      setParams({ filter: { id: Number(id) }, withPaginate: false });
    }
  }, [id]);

  useEffect(() => {
    if (subsections.length > 0) {
      const subsection = subsections[0];
      handleListByStructure({ subsection_id: Number(subsection?.id) }, 'subsection');
      setCategory(subsection?.section?.category);
      setSection(subsection?.section);
    }
  }, [subsections]);

  return (
    <>
      <MainNavbar />
      <div className="SubsectionView" data-testid="SubsectionView">
        <HeaderPage
          title={currentSubsection?.name ?? currentSubsection?.subsection_name ?? ''}
          subtitle={currentSubsection?.description ?? ''}
        />

        <div className="breadcrumb-wrapper">
          <Container>
            <Row className="justify-content-center">
              <Col md={10}>
                <BreadcrumbPage
                  category={category}
                  section={section}
                  subsection={subsections[0]}
                />
              </Col>
            </Row>
          </Container>
        </div>
        <div className="content-wrapper">
          <Container>
            <Row className="justify-content-center py-sm-5 py-3">
              <Col md={10}>
                <ListArticlesView articlesStructure={articlesStructure} viewMode="subsection" />
              </Col>
            </Row>
          </Container>
        </div>
        <ScrollTopButton />
      </div>
    </>
  );
}

export default SubsectionView;
